// extracted by mini-css-extract-plugin
export default {"search_button":"chatstats_search_button__hG8Rw","container":"chatstats_container__DEZpl"};